/* eslint-disable prettier/prettier */
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

interface EmailIngestSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EmailIngestSuccessModal = ({ isOpen, onClose }: EmailIngestSuccessModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Email Ingestion Complete">
      <div className="space-y-4 text-base leading-relaxed text-muted-foreground">
       
        <p>
          A summary has been sent to your inbox, detailing which files were uploaded and which were skipped.
        </p>
       
      </div>
      <div className="flex justify-end mt-6">
        <Button onClick={onClose} className="px-7 sm:px-7">
          Got it
        </Button>
      </div>
    </Modal>
  );
};
